/**
 * @flow
 */

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { format, isSameDay } from 'date-fns';
import { calcEventOffset, calcTimetableHeight } from '../../lib/schedule';

import { CELL_STEP } from './Cell';

// Update position and value of timeline once a minute
const UPDATE_INTERVAL = 60 * 1000;

const Wrapper = styled.div`
    position: absolute;
    top: ${props => props.offset + 8}px;
    left: 108px;
    right: 0px;
    height: 15px;
    margin-top: ${props => props.headerCellHeight - 1}px;
`;

const Line = styled.div`
    position: absolute;
    top: 10px;
    height: 1px;
    width: 100%;
    background-color: #ff3b30;
    z-index: 1;
`;

const Time = styled.div`
    position: absolute;
    text-align: right;
    top: 0px;
    bottom: 0px;
    left: 0px;
    font-size: 14px;
    font-weight: 400;
    color: #ff3b30;
    margin-left: -71px;
    width: 71px;
    height: 20px;
    border: 1px solid #ff3b30;
    border-radius: 5px;
    padding-right: 18px;
    background-color: #fff;
`;

function NowLine({ date, schedule, cellHeight, columns, width, headerCellHeight }) {
    const [now, setNow] = useState(new Date().toISOString());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setNow(new Date().toISOString());
        }, UPDATE_INTERVAL);
        return () => clearInterval(intervalId);
    }, []);

    const offset = calcEventOffset(cellHeight, now, schedule.startAt, CELL_STEP);

    const timelineHeight = calcTimetableHeight(
        cellHeight,
        schedule.startAt,
        schedule.endAt,
        CELL_STEP,
    );

    /**
     * Don't show line if
     * 1. It's out of current schedule
     * 2. Schedule is not for current date
     */
    if (
        !isSameDay(new Date(date), new Date()) ||
        offset < 4 ||
        offset >= timelineHeight
    ) {
        return null;
    }

    return (
        <Wrapper
            offset={offset}
            columns={columns}
            width={width}
            headerCellHeight={headerCellHeight}
        >
            <Time>{format(new Date(), schedule.format)}</Time>
            <Line />
        </Wrapper>
    );
}

export default NowLine;
